export const BACKEND_BASE_URL = window.__ENV__?.VUE_APP_BACKEND_BASE_URL;
export const BACKEND_WEBSOCKET_BASE_URL = window.__ENV__?.VUE_APP_BACKEND_WEBSOCKET_BASE_URL;

export const ENTITY_NAME = "Skole";   // dette var først region

export const STANDARD_PAGINATION_LIMIT = 25;

export const WS_NORMAL_CLOSURE_CODE = 1000;